<template>
  <div class="scene-canvas">
    <div
      class="scene_title blue_header"
    >
      <!-- 灯带场景信息 -->
      <span>{{ $t("sceneCard.lightTripImg") }}</span>
    </div>
    <div class="scene_container">
      <div class="scene_container_upload">
        <div class="scene_container_upload-main">
          <p>{{ $t('visual.uploadImg') }}</p>
          <div class="upload_box">
            <el-upload
              class="avatar-uploader"
              accept="image/*"
              action="xxx"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="onImageChange"
            >
              <img
                v-if="imageUrl"
                :src="imageUrl"
                class="avatar"
              >
              <div
                v-else
                class=""
              >
                <i
                  class="el-icon-plus avatar-uploader-icon"
                />
                <p>{{ $t('visual.please') }}{{ $t('visual.uploadImg') }}, {{ $t('visual.imgSize') }}1000 x 1000px，{{ $t('visual.lessThen') }}100K</p>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="scene_container_upload-article">
          <div class="scene_container_tip_container">
            <p class="scene_container_tip">
              {{ $t('sync.info') }}
            </p>
            <ul class="scene_container_tip-list">
              <li>1、{{ $t('visual.uploadImg') }}</li>
              <li>2、{{ $t('sceneCard.lightTripCanvasInfo2') }}</li>
              <li>3、{{ $t('sceneCard.lightTripCanvasInfo3') }}</li>
              <li>4、{{ $t('sceneCard.lightTripCanvasInfo4') }}</li>
            </ul>
          </div>
          <ul class="scene_container_tip-info">
            <li>
              <div class="scene_container_tip-info_icon">
                <i class="scene-canvas_tool-icon scene-canvas_pencil" />
                <p>{{ $t('sceneCard.lightTripCanvasDraw') }}</p>
              </div>
              <p class="scene_container_tip-info_text">
                {{ $t('sceneCard.lightTripCanvasDrawInfo') }}
              </p>
            </li>
            <li>
              <div class="scene_container_tip-info_icon">
                <i class="scene-canvas_tool-icon scene-canvas_edit" />
                <p>{{ $t('sceneCard.lightTripCanvasEdit') }}</p>
              </div>
              <p class="scene_container_tip-info_text">
                {{ $t('sceneCard.lightTripCanvasEditInfo') }}
              </p>
            </li>
            <li>
              <div class="scene_container_tip-info_icon">
                <i class="scene-canvas_tool-icon scene-canvas_delete" />
                <p>{{ $t('sceneCard.lightTripCanvasDelete') }}</p>
              </div>
              <p class="scene_container_tip-info_text">
                {{ $t('sceneCard.lightTripCanvasDeleteInfo') }}
              </p>
            </li>
            <li>
              <div class="scene_container_tip-info_icon">
                <i class="scene-canvas_tool-icon scene-canvas_back" />
                <p>{{ $t('sceneCard.lightTripCanvasBack') }}</p>
              </div>
              <p class="scene_container_tip-info_text">
                {{ $t('sceneCard.lightTripCanvasBackInfo') }}
              </p>
            </li>   
          </ul>
        </div>
      </div>
      <div class="scene_container_preview">
        <!-- 灯带排列图 -->
        <!-- <p class="upload-preview_title">
          {{ $t("sceneCard.lightTripRankImg") }}:
        </p> -->
        <div class="upload-preview_title" />
        <div id="preview_canvas" />
      </div>
    </div>
  </div>
</template>

<script>
import DrawCanvas, { MODE_TYPE_ENUMS } from '@/components/DrawCanvas/index';
import { loadAsyncImg } from '@/components/DesignCanvas/index';
import { UploadFile } from "@/axios/ICommon.js";
import DesignCanvas from "@/components/DesignCanvas";

export default {
  components: {},
  inject: [],
  props: {
    checkDeviceList: {
      type: Array,
      default: () => [],
    },
    getFirstDeviceId: {
      type: Function,
      default: () => 0
    },
    onCanvasReady: {
      type: Function,
      default: () => 0
    },
    canvasInitData: {
      type: Object,
      default: null
    },
    modeType: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      drawCanvasInstance: null,
      imageUrl: ''
    }
  },

  watch: {
    canvasInitData(data) {
      if (!!data) this.createDrawCanvas(null, initData, initData.modeType);
    }
  },

  mounted() {
    const { canvasInitData } = this;
    if (!!canvasInitData) {
      const origin = window.location.origin;
      const url = canvasInitData.bg.url;
      // canvasInitData.bg.url.replace(
      //   'https://appresource.opple.com', 
      //   origin.includes('//localhost:') ? 'https://stage.opple.com' : origin);
      
      this.imageUrl = url;

      this.createDrawCanvas(null, {
        ...canvasInitData,
        bg: {
          ...canvasInitData.bg || {},
          url,
        },
      }, canvasInitData.modeType);
    }
  },

  destroyed() {
    this.drawCanvasInstance.removeRegist();
  },

  methods: {
    // 创建canvas画布组件
    createDrawCanvas(img = null, initData = null, modeType, onReady = null) {
      this.drawCanvasInstance = new DrawCanvas('#preview_canvas', {
        originImgData: img,
        // 模式 LINE 线模式 CIRCLE 圆模式
        modeType,
        // 非必传 初始化数据 用于回显
        initData,
        // 非必传 第一个设备的图层id 此处用deviceId关联 不传则默认0
        firstLayerId: (this.checkDeviceList[0] || {}).VDeviceId,
        // 非必传  舞台的参数配置 参考@DrawCanvas/renderOption 默认值
        // stageOption: {}, 
        // 非必传  绘画的参数配置 参考@DrawCanvas/renderOption 默认值
        // drawOption: {},
        // 非必传 按钮配置 传入icon信息 以及 按钮文案信息 不传则用默认值
        btnConfig: {
          draw: {
            isShow: true,
            icon: 'scene-canvas_tool-icon scene-canvas_pencil',
            text: this.$t('sceneCard.lightTripCanvasDraw'),
            onclick: () => {},
            callBack: () => {}
          },
          edit: {
            icon: 'scene-canvas_tool-icon scene-canvas_edit',
            text: this.$t('sceneCard.lightTripCanvasEdit'),
          },
          delete: {
            icon: 'scene-canvas_tool-icon scene-canvas_delete',
            text: this.$t('sceneCard.lightTripCanvasDelete'),
          },
          deleteLast: {
            icon: 'scene-canvas_tool-icon scene-canvas_back',
            text: this.$t('sceneCard.lightTripCanvasBack'),
          }
        },
        // 非必传 线圈点击后高亮回调 可以用于触发当前设备图层回调
        onActive: (VDeviceId) => {
          this.$emit('onDeviceActive', VDeviceId)
        },

        // 非必传 初始化后的钩子
        onReady
      });

      this.$emit('canvasReady', this.drawCanvasInstance);
    },

    setCurLineLayerIndex(deviceId) {
      if (this.drawCanvasInstance) {
        this.drawCanvasInstance.setCurLineLayerIndex(deviceId);
      }
    },

    async onImageChange(file) {
      const url = URL.createObjectURL(file.raw);
      const img = await loadAsyncImg(url);

      const { width, height } = img;
      
      if (width > 1000 || height > 1000) {
        this.$message.error(
          `${this.$t('visual.uploadImg')}${this.$t('sceneCard.size')}${this.$t('lastLight.lessthan')}1000 x 1000`
        );

        return;
      }

      if (file.size > 1000000) {
        this.$message.error(`${this.$t('visual.uploadImg')}${this.$t('lastLight.lessthan')}100k`)

        return;
      }

      const formData = new FormData();

      formData.append("file", file.raw);

      // ========
      // this.createDrawCanvas(img, null, () => {    
      //   const mapIds = this.checkDeviceList.map(item => ({
      //       mapId: item.VDeviceId
      //     })) 

      //   this.drawCanvasInstance.createRandomLine(mapIds);
      //   this.drawCanvasInstance.divideEqually();
      // });

      // this.$emit('imgUpdate', {
      //   drawCanvasInstance: this.drawCanvasInstance,
      //   bgUrl: url
      // });

      // this.imageUrl = url;

      // return
      // ========

      UploadFile(formData, (res) => {
        if (res.StatusCode === this.$store.state.rightStatusCode) {
          const { canvasInitData = {}} = this;
          const modeType = this.modeType || canvasInitData.modeType;
          const cdnUrl = res.Result.RootPath + res.Result.FilePath;
          this.imageUrl = url;
          
          this.createDrawCanvas(img, null, modeType, () => {    
            const mapIds = this.checkDeviceList.map(item => ({
              mapId: item.VDeviceId
            })) 

            this.drawCanvasInstance.createRandom(mapIds);
            this.drawCanvasInstance.divideEqually();
          });

          this.$emit('imgUpdate', {
            drawCanvasInstance: this.drawCanvasInstance,
            bgUrl: cdnUrl
          });
        }
      });
    },

    addLamp(deviceId, lampCount, lampInfoList) {
      if (!this.drawCanvasInstance) return;

      // 高亮设备 做渲染
      this.drawCanvasInstance.setCurLineLayerIndex(deviceId);
      // 增加灯泡 且不渲染
      this.drawCanvasInstance.addLamp(lampCount, lampInfoList);
    },

    getColors() {
      if (!this.drawCanvasInstance) return;
  
      const colors = this.drawCanvasInstance.getColors();

      return colors;
    },

    getColors2() {
      if (!this.drawCanvasInstance) return;
      const colors = this.drawCanvasInstance.getColors();
      const m = document.createElement('div');

      Object.values(colors).forEach(list => {
        list.forEach((item, i) => {
          const c = `rgb(${item.rgba.replace(/,255$/, '')})`
          // const rgbaList = item.rgba.split(',') || [];

          // const CxCy = DesignCanvas.transRgbToCxCy(
          //       Number(rgbaList[0]), 
          //       Number(rgbaList[1]), 
          //       Number(rgbaList[2])
          //     );

          // console.log('CxCy', i, c, CxCy, `${Number(255).toString(16)}${CxCy}`);
          
          const d = document.createElement('div');
          d.style = `width:20px;height:20px;margin-left:10px;border:1px solid #333;float:left;background:${c}`;
          m.append(d)
        })
        const d = document.createElement('div');
          d.style = `width:5px;height:20px;margin-left:10px;float:left;background:#222;`;
          m.append(d)
      })
      
      document.querySelector('.upload-preview_title').appendChild(m);
    },

    getSave() {
      if (!this.drawCanvasInstance) return;

      const data = this.drawCanvasInstance.getSaveData();
      console.log('saveData', data);

      localStorage.setItem('testCanvas', JSON.stringify(data));
    },

    divideEqually() {
      this.drawCanvasInstance && this.drawCanvasInstance.divideEqually();
    }
  },
};
</script>

<style lang="scss" scoped>
.scene-canvas {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .scene_container {
    // display: flex;
    width: 100%;
    box-sizing: border-box;
  }
  .scene_container_preview {
    flex: 1;
  }

  #preview_canvas {
    width: 100%;
    height: 1236px;
    margin-top: 20px;
    // border: 1px solid #eee;
    background: url(../../../../components/DrawCanvas/assets/psBg.png) repeat;
    background-size: 40px 40px;
  }

  .scene_container_upload {
    display: flex;
    margin-bottom: 60px;
  }

  .scene_container_upload-article {
    display: flex;
    padding-top: 55px;
    padding-left: 20px;
  }


.upload_box {
  display: flex;
  width: 238px;
  height: 238px;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  color: #D0D0D0;
  overflow: hidden;

  p {
    margin-top: 10px;
  }
  ::v-deep .el-icon-plus {
    font-size: 80px;
    font-weight: bold;
    
  }

  img {
    max-width: 100%;
  }
}

.scene_container_tip_container {
  width: 350px;
}

.scene_container_tip {
  // margin-top: 30px;
  margin-bottom: 5px;
}

.scene_container_tip-info {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: flex-start;
  height: 60px;
  max-width: 534px;

  li {
    display: flex;
    width: 50%;
    max-width: 267px;
    margin-bottom: 16px;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .scene_container_tip-info_icon {
    display: flex;
    min-width: 86px;
    min-height: 86px;
    max-width: 86px;
    max-height: 86px;
    padding: 6px;
    background: #0B3687;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    color: #fff;
    box-sizing: border-box;
    // white-space: nowrap;
    text-align: center;
    .scene-canvas_tool-icon {
      width: 30px;
      height: 30px;
    }
    p {
      width: 100%;
      margin-top: 4px;
      font-size: 12px;
    }
   
  }

  .scene_container_tip-info_text {
    display: flex;
    width: 220px;
    margin-left: 15px;
  }
}

}
</style>

<style lang="scss">
.scene-canvas_tool-icon{
  display: block;
  width: 25px;
  height: 25px;
  margin: 0 auto;
}

.scene-canvas_pencil {
  background: url("~@/assets/img/visual/tool-pencil.png") no-repeat 0 0 / 100%
    100%;
}

.scene-canvas_edit {
  background: url("~@/assets/img/visual/edit.png") no-repeat 0 0 / 100%
    100%;
}

.scene-canvas_delete {
  background: url("~@/assets/img/visual/delete.png") no-repeat 0 0 / 100%
      100%;
}

.scene-canvas_back {
  background: url("~@/assets/img/visual/back.png") no-repeat 0 0 / 100%
      100%;
} 
</style>

